import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/chat/chatRequest_on.svg'


const _hoisted_1 = { class: "fullHeightModal hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "chatMessageContainer" }
const _hoisted_7 = {
  class: "writerContainer",
  ref: "chatWriter"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comment = _resolveComponent("comment")!
  const _component_textarea_autosize = _resolveComponent("textarea-autosize")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.comments, (item) => {
        return (_openBlock(), _createBlock(_component_comment, {
          class: { reply: !!_ctx.firstComment },
          key: item.identifier,
          comment: item,
          showReplyButton: _ctx.showReplyButton,
          onReply: _ctx.reply,
          onDeletePost: ($event: any) => (_ctx.deletePost(item.identifier))
        }, null, 8, ["class", "comment", "showReplyButton", "onReply", "onDeletePost"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_textarea_autosize, {
        placeholder: _ctx.placeholder,
        modelValue: _ctx.vm.text,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.text = $event)),
        "max-height": 80,
        ref: "chatInput"
      }, null, 8, ["placeholder", "modelValue"]),
      _createVNode("div", {
        class: "squareButton ms-2",
        disabled: !_ctx.vm.text.trim(),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.send()))
      }, [
        _hoisted_8
      ], 8, ["disabled"])
    ], 512)
  ]))
}